import React, { useEffect, useState } from "react";
import { approveExternalOrganisationMedia, getMediaAwaitingApproval, MediaAwaitingApprovalModel } from "../../../api/mediaApi";
import { formatDurationShort } from "../../../services/common";
import MediaPreviewControl from "../../components/mediaPreviewControl/MediaPreviewControl";
import { Spinner } from "../../components/globalsSpinner/GlobalSpinner";
import { Button } from "../../components/Button";
import MediaPreviewModal from "../../components/mediaPreviewModal/MediaPreviewModal";
import { formatDate, formatTimeOnly } from "../../../services/dateService";

const MediaAwaitingApproval = () => {
    let [media, setMedia] = useState<MediaAwaitingApprovalModel[]>([]);
    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [processingMediaId, setProcessingMediaId] = useState<string | null>(null);
    let [mediaIdForPreview, setMediaIdForPreview] = useState<string>('');
    let [showMediaInfoModal, setShowMediaInfoModal] = useState<boolean>(false);

    const updateMediaAwaitingApproval = async () => {
        setIsLoading(true);
        let result = await getMediaAwaitingApproval();
        if(result.type === "succes") {
            setMedia(result.data.items);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        updateMediaAwaitingApproval();
    }, []);

    const approveMedia = async (mediaId: string, isApproved: boolean) => {
        setProcessingMediaId(mediaId);
        let result = await approveExternalOrganisationMedia({mediaId, isApproved});
        if(result.type === "succes") {
            setMedia(currentMedia => {
                let updatedMedia = currentMedia.filter(item => item.id !== mediaId);
                return updatedMedia;
            });
        }
        setProcessingMediaId(null);
    }

    const showMediaPreview = (item: MediaAwaitingApprovalModel) => {
        setMediaIdForPreview(item.id);
        setShowMediaInfoModal(true);
    }

    const closeMediaPreview = () => {
        setShowMediaInfoModal(false);
    }

    const renderMediaName = (item: MediaAwaitingApprovalModel) => {
        let mediaName = <span className="file-name" onClick={() => showMediaPreview(item)}>{item.name}</span>;
        return mediaName;
    }

    const renderCampaigns = (item: MediaAwaitingApprovalModel) => {
        if(!item.campaigns.length) {
            return <span>-</span>;
        }

        let campaignElements = item.campaigns.map(campaign => <p key={campaign}>{campaign}</p>);
        return campaignElements;
    }

    const renderFlightDates = (item: MediaAwaitingApprovalModel) => {
        if(!item.flightDates || !item.flightDates.length) {
            return <span>-</span>;
        }

        let flightDates = item.flightDates.map((flightDate, index) => {
            let flightDateElement = <p className="media-awaiting-approval-flight-date" key={`${flightDate.start}-${flightDate.end}-${index}`}>
                <span>{formatDate(flightDate.start)} - {formatDate(flightDate.end)} </span>
                {flightDate.startTime && flightDate.endTime && <span>{formatTimeOnly(flightDate.startTime)} - {formatTimeOnly(flightDate.endTime)}</span>}
            </p>;

            return flightDateElement;
        });

        return flightDates;
    }

    const renderActions = (item: MediaAwaitingApprovalModel) => {
        let isProcessing = processingMediaId === item.id;
        let actions = <div className="media-awaiting-approval-actions">
            <Button color="green" label="Approve" onClick={() => approveMedia(item.id, true)} isDisabled={isProcessing} />
            <Button color="gray" label="Reject" onClick={() => approveMedia(item.id, false)} isDisabled={isProcessing} />
        </div>;

        return actions;
    }

    const renderRows = () => {
        let rows = media.map(item => <tr key={item.id}>
            <td>
                <MediaPreviewControl mediaType={item.mediaType} previewUrl={item.previewUrl} />
            </td>
            <td>{renderMediaName(item)}</td>
            <td>{renderCampaigns(item)}</td>
            <td>{renderFlightDates(item)}</td>
            <td>{formatDate(item.requestDate)}</td>
            <td>{formatDurationShort(item.durationMs)}</td>
            <td>{renderActions(item)}</td>
        </tr>);

        return rows;
    }

    let component = <div className="media-awaiting-approval mb-20">
        <h2>Media Awaiting Approval</h2>
        {isLoading && <div className="media-awaiting-approval-loading">
            <Spinner />
        </div>}
        {!isLoading && !media.length && <div className="media-awaiting-approval-empty">
            No media awaiting approval
        </div>}
        {!isLoading && !!media.length && <table className="table media-table media-awaiting-approval-table">
                <thead>
                    <tr>
                        <td></td>
                        <td>File Name</td>
                        <td>Campaign Name</td>
                        <td>Flight Dates</td>
                        <td>Submitted</td>
                        <td>Duration</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {renderRows()}
                </tbody>
            </table>
        }
        <MediaPreviewModal
            mediaId={mediaIdForPreview}
            show={showMediaInfoModal}
            onRequestClose={closeMediaPreview}
            onUpdated={updateMediaAwaitingApproval}
            mode="readonly"
        />
    </div>

    return component;
}

export default MediaAwaitingApproval;
